import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import { background } from 'styled-system';
import TilePopdownMenu from './TilePopdownMenu';
import ShadowOverlayButtons from './ShadowOverlayButtons';
import {
  SmallTileContainer,
  Thumbnail,
  ThumbnailOverlay,
  Headline,
  Overlay,
  TileButtons,
  RibbonTagAndIncompleteTagWrapper,
} from './StyledComponents';
import { Loading } from './Loading';
import RibbonTagComponent from './RibbonTagComponent';
import IncompleteTagComponent from './IncompleteTagComponent';
import { imgOnError } from '../helpers';
import { useTileView } from '../../lib/redux/hooks/useTileView';

const ViewButton = styled.div`
  ${background};
  width: 100%;
  font-size: 12px;
  height: 24px;
  border-radius: 0px 0px 8px 8px;
  color: ${themeGet('colors.white')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: relative;
  top: 147px;
`;

const CampaignTag = styled.div`
  background-color: ${props => props.background};
  height: 8px;
  border-radius: 6px 6px 0px 0px;
  width: 100%;
  height: 8px;
  position: absolute;
  top: 0px;
`;

const airboBlue = '#007EFF';
const lightBlue = '#3398FF';
const darkBlue = '#046EEF';

const SmallTileComponent = ({
  id,
  thumbnail,
  ribbonTagColor,
  ribbonTagName,
  loading,
  headline,
  ignored,
  fullyAssembled,
  status,
  planDate,
  currentTab,
  editPath,
  audienceColor,
}) => {
  const { setTileView } = useTileView();
  const { t } = useTranslation('shared');

  const [currentColor, setCurrentColor] = useState(airboBlue);

  return (
    <SmallTileContainer
      id={`single-tile-${id}`}
      onClick={() => setTileView({ tileId: id, currentTab })}
    >
      {audienceColor && <CampaignTag background={audienceColor} />}
      <Thumbnail src={thumbnail} onError={imgOnError} />
      <RibbonTagAndIncompleteTagWrapper hasRibbonTag={ribbonTagName}>
        {ribbonTagName && (
          <RibbonTagComponent
            ribbonTagName={ribbonTagName}
            ribbonTagColor={ribbonTagColor}
            height="28"
          />
        )}
        {!fullyAssembled && <IncompleteTagComponent />}
      </RibbonTagAndIncompleteTagWrapper>
      <ThumbnailOverlay isLoading={loading} ignored={ignored} />
      <Headline>{!loading && headline}</Headline>

      <Overlay>
        <TileButtons className="tile_buttons">
          <ShadowOverlayButtons
            currentTab={currentTab}
            id={id}
            ignored={ignored}
            status={status}
            planDate={planDate}
            editPath={editPath}
            fullyAssembled={fullyAssembled}
          />
        </TileButtons>
        <div className="tile-popdown-menu new-popdown-menu">
          <TilePopdownMenu id={id} ignored={ignored} status={status} />
        </div>
      </Overlay>
      {loading && <Loading />}
      <ViewButton
        onMouseDown={() => setCurrentColor(darkBlue)}
        onMouseUp={() => setCurrentColor(airboBlue)}
        onMouseEnter={() => setCurrentColor(lightBlue)}
        onMouseLeave={() => setCurrentColor(airboBlue)}
        background={currentColor}
        onClick={() => setTileView({ tileId: id, currentTab })}
      >
        {t('tileComponent.view')}
      </ViewButton>
    </SmallTileContainer>
  );
};

SmallTileComponent.propTypes = {
  id: PropTypes.string,
  embedVideo: PropTypes.any,
  thumbnail: PropTypes.any,
  ribbonTagName: PropTypes.string,
  ribbonTagColor: PropTypes.string,
  tileThumblinkOnClick: PropTypes.func,
  loading: PropTypes.bool,
  headline: PropTypes.string,
  ignored: PropTypes.bool,
  fullyAssembled: PropTypes.bool,
  currentTab: PropTypes.string,
  editPath: PropTypes.string,
  planDate: PropTypes.string,
  status: PropTypes.string,
  audienceColor: PropTypes.string,
};

export default SmallTileComponent;
